import React from "react";
import eyeBrowBanner from "./../../../../../Images/Blog/Why_Eyebrow_Shaping/Banner.png";

const WhyEyeBrowImg = () => {
  return (
    <div className="blogImg-content">
      <img src={eyeBrowBanner} alt="eyeBrowBanner" loading="lazy" />
    </div>
  );
};

export default WhyEyeBrowImg;
